export enum Placement {
  Auto = 'auto',
  Top = 'top',
  Bottom = 'bottom',
  Right = 'right',
  Left = 'left',
  AutoStart = 'auto-start',
  AutoEnd = 'auto-end',
  TopStart = 'top-start',
  TopEnd = 'top-end',
  BottomStart = 'bottom-start',
  BottomEnd = 'bottom-end',
  RightStart = 'right-start',
  RightEnd = 'right-end',
  LeftStart = 'left-start',
  LeftEnd = 'left-end',
}

export enum TriggerType {
  Click = 'click',
  Hover = 'hover',
  Focus = 'focus',
}
